"use client";

import { TFunction } from "i18next";
import { VoiceOption } from "@/types/agencies";
import VoiceCard from "./VoiceCard";

interface VoiceCardGridProps {
  voices: readonly VoiceOption[];
  selectedVoiceId: string | undefined;
  onVoiceSelect: (voice: VoiceOption) => void;
  changeMarker: string;
  setPlaying: (audioId: string) => void;
  translateCommon: TFunction;
  translateSettings: TFunction;
  orgId?: string;
}

export default function VoiceCardGrid({
  voices,
  selectedVoiceId,
  onVoiceSelect,
  changeMarker,
  setPlaying,
  translateCommon,
  translateSettings,
  orgId,
}: Readonly<VoiceCardGridProps>) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
      {voices.map((voice) => (
        <VoiceCard
          key={voice.id}
          voice={voice}
          isSelected={selectedVoiceId === voice.id}
          onSelect={() => onVoiceSelect(voice)}
          changeMarker={changeMarker}
          setPlaying={setPlaying}
          translateCommon={translateCommon}
          translateSettings={translateSettings}
          orgId={orgId}
        />
      ))}
    </div>
  );
}
